// extracted by mini-css-extract-plugin
export default {"label":"label__3VLw5","optionalLabel":"optionalLabel__2zFvI","imageUploadSpacing":"imageUploadSpacing__apohD"};